import React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ForeFlightLogo from "../../../common/ForeFlightLogo";
import JDMLogo from "../../../common/JDMLogo";
import JeppesenForeFlightLogo from "../../../common/JeppesenForeFlightLogo";

const StyledWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    a {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        color: inherit;
    }
`;

interface Props {
    show: boolean;
}

const JeppesenForeFlightHeader = ({ show }: Props) => {
    if (!show) {
        return null;
    }
    return (
        <StyledWrapper>
            <a href={'https://foreflight.com'}>
                <JeppesenForeFlightLogo />
            </a>
        </StyledWrapper>
    );
};

export default JeppesenForeFlightHeader;
